import { useState } from 'react';
import { Chip } from '@mui/material';
import {
  useCreateItemTagMutation,
  useCreateTagMutation,
  useDeleteItemTagMutation,
  useGetItemTagsQuery,
  useGetTagsQuery,
} from 'store/api';
import { getIn, FormikHelpers } from 'formik';

export const useTagForm = (item: number, refetch: Function) => {
  const [tagLoading, setTagLoading] = useState<boolean>(false);
  const { data: tags = [] } = useGetTagsQuery({});
  const { data: item_tags = [] } = useGetItemTagsQuery(
    {
      params: { item: item, nested: 'all' },
    },
    { skip: !item }
  );

  const [createTag] = useCreateTagMutation();
  const [createItemTag] = useCreateItemTagMutation();
  const [deleteItemTag] = useDeleteItemTagMutation();

  return {
    name: 'tags',
    itemType: 'autocomplete',
    options: tags.filter(
      (t: any) => !item_tags?.find((r: any) => t.id === r.tag)
    ),
    multiple: true,
    label: 'Tags',
    loading: tagLoading,
    gridProps: { xs: 12 },
    value: item_tags,
    jItemProps: {
      disableClearable: true,
      onChange: async (tags: any[]) => {
        if (tags && Array.isArray(tags) && tags.length > 0) {
          tags.forEach(async (tag: any) => {
            if (!tag.tag) {
              setTagLoading(true);
              await createItemTag({
                tag: tag.id,
                item: item,
              });
              refetch && refetch();
              setTagLoading(false);
            }
          });
        }
      },
      addValue: async (
        name: any,
        newValue: any,
        values: any,
        formik: FormikHelpers<any>
      ) => {
        const tag = await createTag({
          name: newValue?.inputValue,
        }).unwrap();
        if (tag.id) {
          await createItemTag({
            tag: tag.id,
            item: item,
          });

          // setTimeout(function () {
          //   formik.setFieldValue(name, [...(getIn(values, name) || []), tag]);
          // }, 500);
        }
      },
      renderTags: (value: readonly string[], getTagProps: any) => {
        return value?.map((option: any, index: number) => {
          return (
            <Chip
              variant="outlined"
              color="secondary"
              label={typeof option === 'string' ? option : option.name}
              size="small"
              {...getTagProps({ index })}
              onDelete={async props => {
                setTagLoading(true);
                if (option.id) {
                  await deleteItemTag(option.id);
                  refetch();
                  getTagProps({ index }).onDelete(props);
                }
                setTagLoading(false);
              }}
            />
          );
        });
      },
    },
  };
};
